 /** ## Timezone Controller
 *
 * @module src/controllers/timezone
 */

'use strict';

const moment = require('moment-timezone');

/** Init
 */
const init = (kd) => {
    const timezone = kd.doc('location')[0].timezone; // 'America/New_York';
    moment.tz.setDefault(timezone);
};

const m = (kd) => {
    return moment;
};

module.exports = {
    init,
    m,
};




/** WEBPACK FOOTER **
 ** ./src/controllers/timezone/index.js
 **/